import { IDictionary } from '@ViewModels';
import ElementDtd from './elements.dtd.json';

interface IHtmlEditorDtd {
	attrMap: IDictionary<string[]>;
	commonAttrs: string[];
	customElements: string[];
	elements: string[];
}

const Dtd = ElementDtd as IHtmlEditorDtd;

/**
 * `attrMap` is keyed by the entry exactly as it appears in `elements`, TinyMCE prefix included
 * (`#div` and `#p` both carry `align`), so the key must stay the unmodified string. An alias entry
 * such as `p/li` has no `attrMap` entry of its own and gets the common attributes only.
 */
const buildValidElementsStringValue = (elements: string[]) =>
	elements.reduce((result, element) => {
		const attrsStringValue = [...Dtd.commonAttrs, ...(Dtd.attrMap[element] || [])].filter(x => !!x).join('|');
		return `${result}${result ? ',' : ''}${element}${attrsStringValue ? `[${attrsStringValue}]` : ''}`;
	}, '');

export const ValidElementsStringValue = buildValidElementsStringValue(Dtd.elements);

/**
 * Block elements are aliased to `p` rather than left out: TinyMCE unwraps an element it does not
 * recognize and keeps the children inline, which would run a pasted list together as "onetwo".
 */
const TextMessageBlockElementAliases = [
	'address',
	'blockquote',
	'caption',
	'center',
	'dd',
	'dt',
	'h1',
	'h2',
	'h3',
	'h4',
	'h5',
	'h6',
	'li',
	'pre',
	'td',
	'th',
].map(element => `p/${element}`);

/**
 * A text message is delivered as plain text, so the only structure that survives the wire is a line
 * break. Anything richer renders in the composer and is then silently dropped on send, and `a`/`img`
 * lose their address outright, so a pasted "click here" reaches the recipient as dead text. Levitate-API
 * enforces the same allow-list (`lev-content`, `div`, `p`, `span`, `br`) on text content.
 *
 * The alias rules must come first: TinyMCE registers `p/li` under both `li` and `p`, so a trailing
 * `#p` is what leaves `p` with its padd-empty behavior intact.
 */
export const TextMessageValidElementsStringValue = buildValidElementsStringValue([
	...TextMessageBlockElementAliases,
	'span',
	'br',
	'#div',
	'#p',
]);
